import { alpha, styled as styledMui } from "@mui/material";
import styled from "styled-components";
// import UploadDropZone from "@rpldy/upload-drop-zone";

export const DropArea = styledMui("div")(({ theme }) => ({
  border: `2px dashed ${theme.palette.primary.main}`,
  height: "auto",
  minHeight: "100px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  padding: "10px",

  "&.active": {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
  },
}));
